import React from 'react';
import styled from 'styled-components';
import { isBlank } from 'utils/storeUtils';

function parseMessage(input) {
  const regex = /\[(.*?)\]/g;
  const matches = input.matchAll(regex);

  let lastIndex = 0;
  const parsedMessage = [];

  for (const match of matches) {
    const comment = match[1];
    const startIndex = match.index;
    const endIndex = startIndex + match[0].length;
    // Add the text before the comment
    if (startIndex > lastIndex) {
      parsedMessage.push(
        <span style={{ display: 'inline' }}>
          {input.substring(lastIndex, startIndex).trim()}&nbsp;&nbsp;
        </span>
      );
    }

    // Add the comment wrapped in a span
    parsedMessage.push(
      <Comment key={startIndex} className="comment" style={{ display: 'inline' }}>
        {comment.trim()}&nbsp;&nbsp;
      </Comment>
    );

    lastIndex = endIndex;
  }

  // Add the text after the last comment
  if (lastIndex < input.length) {
    parsedMessage.push(
      <span style={{ display: 'inline' }}>
        {input.substring(lastIndex).trim()}&nbsp;&nbsp;
      </span>
    );
  }

  return parsedMessage;
}

export default function UserMessageTool(props) {
  const { text } = props;
  if (isBlank(text)) {
    return null;
  }

  return (
    parseMessage(text)
  );
}

const Comment = styled.span`
  font-style: italic;
  display: inline-block;
  color: #A9A9A9;
`;
